import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";
import { HttpService } from "./http.service";

import { PersonService } from "./person.service";

@Injectable()
export class SearchComponentService {
  private searchUrl = "";

  constructor(private http: HttpService, private personService: PersonService) {
    this.searchUrl = "";
    this.personService;
  }

  getSearchNames(
    selected: any,
    searchApi: string,
    searchName: string,
    campusCode: string
  ) {
    this.searchUrl = `${searchApi}/${searchName}/campusCode/${campusCode}`;

    return this.http.get(`${this.searchUrl}`).then((res) => {
      const results = res ? res["options"] || [] : [];
      return results.filter(
        (element) => selected.indexOf(element.value) === -1
      );
    });
  }

  getSearchURL(): string {
    return this.searchUrl;
  }

  upsertPerson(user: any) {
    return this.personService.getUserDetails(user.value || user.userId);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/search-component.service.ts